export var transformToDepartmentsProp = function transformToDepartmentsProp(content) {
  return content.l1_navigation.map(function (l1) {
    var _l1$l1_navigation_lin, _l1$l1_navigation_lin2;
    var displayText = l1.l1_display_text || ((_l1$l1_navigation_lin = l1.l1_navigation_link[0]) === null || _l1$l1_navigation_lin === void 0 ? void 0 : _l1$l1_navigation_lin.title) || 'no display text for level 1';
    return {
      // TODO: rename from columns when old nav has been removed
      columns: [l1.l2_navigation.map(function (l2) {
        var _l2$l2_navigation_lin, _l2$l2_navigation_lin2;
        return {
          title: l2.l2_display_text || ((_l2$l2_navigation_lin = l2.l2_navigation_link[0]) === null || _l2$l2_navigation_lin === void 0 ? void 0 : _l2$l2_navigation_lin.title) || 'no display text for level 2',
          url: ((_l2$l2_navigation_lin2 = l2.l2_navigation_link[0]) === null || _l2$l2_navigation_lin2 === void 0 ? void 0 : _l2$l2_navigation_lin2.url) || '',
          titleType: 'regular_link',
          items: l2.l3_navigation.map(function (l3) {
            var _l3$l3_navigation_lin, _l3$l3_navigation_lin2;
            return {
              title: l3.l3_display_text || ((_l3$l3_navigation_lin = l3.l3_navigation_link[0]) === null || _l3$l3_navigation_lin === void 0 ? void 0 : _l3$l3_navigation_lin.title) || 'no display text for level 3',
              url: ((_l3$l3_navigation_lin2 = l3.l3_navigation_link[0]) === null || _l3$l3_navigation_lin2 === void 0 ? void 0 : _l3$l3_navigation_lin2.url) || ''
            };
          })
        };
      })],
      seoLinks: [],
      title: displayText,
      url: ((_l1$l1_navigation_lin2 = l1.l1_navigation_link[0]) === null || _l1$l1_navigation_lin2 === void 0 ? void 0 : _l1$l1_navigation_lin2.url) || ''
    };
  });
};